export default {
  data: () => ({
    clickedWithoutDragging: false,
    dragX: 0,
    dragY: 0,
  }),

  methods: {
    mousedownHandler(e) {
      this.dragX = e.pageX;
      this.dragY = e.pageY;
      this.clickedWithoutDragging = true;
    },
    mousemoveHandler(e) {
      const diffX = Math.abs(e.pageX - this.dragX);
      const diffY = Math.abs(e.pageY - this.dragY);
      const delta = 20;

      if (diffX > delta || diffY > delta) {
        this.clickedWithoutDragging = false;
      }
    },

    doIfSingleClick(action) {
      if (this.clickedWithoutDragging) {
        action();
      }
      this.clickedWithoutDragging = false;
    },
  },
};
